import React from "react";
import EnquiryBanner from "./EnquiryBanner";
import logo from "./images/logo.png";

// ============ SOCIAL ICONS (inline SVG — no dependency) ============
const FacebookIcon = () => (
  <svg viewBox="0 0 320 512" width="16" height="16" fill="currentColor" aria-hidden="true">
    <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
  </svg>
);

const XIcon = () => (
  <svg viewBox="0 0 512 512" width="16" height="16" fill="currentColor" aria-hidden="true">
    <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 448 512" width="16" height="16" fill="currentColor" aria-hidden="true">
    <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
  </svg>
);

const YoutubeIcon = () => (
  <svg viewBox="0 0 576 512" width="16" height="16" fill="currentColor" aria-hidden="true">
    <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" />
  </svg>
);



function Footer() {
  const year = new Date().getFullYear();

  return (
    <>
    <EnquiryBanner />
      <footer className="site-footer">
        {/* Main columns */}
        <div className="footer-main">
          {/* Brand column */}
          <div className="footer-col footer-brand">
            <img
              src={`${logo}`}
              alt="Prosep Services"
              className="footer-logo"
            />
            <p className="footer-tagline">
              Your trusted source for mining, laboratory &amp; security
              solutions across Ghana and West Africa.
            </p>
            <div className="footer-socials">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <FacebookIcon />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noreferrer"
                aria-label="X (Twitter)"
              >
                <XIcon />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <InstagramIcon />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noreferrer"
                aria-label="YouTube"
              >
                <YoutubeIcon />
              </a>
            </div>
          </div>

          {/* Shop column — matches the categories from your data */}
          <div className="footer-col">
            <h4 className="footer-heading">Shop</h4>
            <ul>
                <a href="/product/category/cctv">Cctv</a>
                <a href="/product/category/chemicals">Chemicals</a>
                <a href="/product/category/door-security">Door Security</a>
                <a href="/product/category/lab-equipment-consumables">
                  Lab Equipment &amp; Consumables
                </a>
                <a href="/product/category/loto-occupational-safety">
                  Loto: Occupational Safety
                </a>
                <a href="/product/category/ppe">Ppe</a>
                <a href="/product/category/padlock">Padlock</a>
                <a href="/product/category/pump-accessories-spare-parts">
                  Pump Accessories - Spare Parts
                </a>
                <a href="/product/category/pumps">Pumps</a>
                <a href="/product/category/torchlight">Torchlights</a>
            </ul>
          </div>

          {/* Company column */}
          <div className="footer-col">
            <h4 className="footer-heading">Company</h4>
            <ul>
              <li><a href="/about">About Us</a></li>
              <li><a href="/services/mining-mineral-processing">Mining & Mineral Processing</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          {/* Contact column */}
          <div className="footer-col">
            <h4 className="footer-heading">Get in Touch</h4>
            <ul className="footer-contact">
              <li>
                <span className="footer-icon">📍</span>
                P.O. Box 6913, Accra-North, Ghana
              </li>
              <li>
                <span className="footer-icon">📞</span>
                <a href="tel:+233302790300">+233 (0) 302 790300</a>
              </li>
              <li>
                <span className="footer-icon">📱</span>
                <a href="tel:+233244235128">+233 (0) 244 235 128</a>
              </li>
              <li>
                <span className="footer-icon">✉️</span>
                <a href="mailto:info@prosepservices.com">info@prosepservices.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-inner">
            <p>© {year} Prosep Services Ltd. All rights reserved.</p>
            <div className="footer-bottom-links">
              <a href="/privacy">Privacy Policy</a>
              <a href="/terms">Terms of Service</a>
              <a href="/returns">Returns</a>
            </div>
          </div>
        </div>
      </footer>

      <style>{`
        .site-footer {
          background: #111827;
          color: #d1d5db;
          font-family: Arial, sans-serif;
        }

        /* ============ MAIN SECTION ============ */
        .footer-main {
          max-width: 1400px;
          margin: 0 auto;
          padding: 60px 40px 40px;
          display: grid;
          grid-template-columns: 1.4fr 1.1fr 1fr 1.3fr;
          gap: 48px;
        }

        /* Brand column */
        .footer-brand {
          display: flex;
          flex-direction: column;
        }
        .footer-logo {
          height: 72px;
          width: 230px;
          display: block;
          margin-bottom: 18px;
          filter: brightness(0) invert(1);
          opacity: 0.95;
          object-fit: contain;
        }
        .footer-tagline {
          font-size: 14px;
          line-height: 1.7;
          color: #9ca3af;
          margin: 0 0 22px;
          max-width: 340px;
        }

        /* Social icons */
        .footer-socials {
          display: flex;
          gap: 12px;
        }
        .footer-socials a {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #1f2937;
          color: #d1d5db;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          transition: all 0.2s ease;
        }
        .footer-socials a:hover {
          background: #c8102e;
          color: #fff;
          transform: translateY(-3px);
        }
        .footer-socials svg {
          width: 16px;
          height: 16px;
        }

        /* Columns */
        .footer-col h4 {
          color: #ffffff;
          font-size: 15px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin: 0 0 20px;
          padding-bottom: 12px;
          position: relative;
        }
        .footer-col h4::after {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 36px;
          height: 2px;
          background: #c8102e;
        }

        .footer-col ul {
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          flex-direction: column;
          gap: 24px;
        }
        .footer-col ul a {
          color: #9ca3af;
          text-decoration: none;
          font-size: 14px;
          transition: color 0.15s ease, padding-left 0.15s ease;
          display: inline-block;
        }
        .footer-col ul a:hover {
          color: #ffffff;
          padding-left: 6px;
        }

        /* Contact list */
        .footer-contact li {
          display: flex;
          align-items: flex-start;
          gap: 12px;
          font-size: 14px;
          color: #9ca3af;
          line-height: 1.6;
        }
        .footer-contact a {
          color: #9ca3af;
          text-decoration: none;
        }
        .footer-contact a:hover {
          color: #ffffff;
        }
        .footer-icon {
          font-size: 15px;
          flex-shrink: 0;
          display: inline-block;
          min-width: 20px;
        }

        /* ============ BOTTOM BAR ============ */
        .footer-bottom {
          border-top: 1px solid #1f2937;
          background: #0b1120;
        }
        .footer-bottom-inner {
          max-width: 1400px;
          margin: 0 auto;
          padding: 22px 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 16px;
        }
        .footer-bottom p {
          margin: 0;
          font-size: 13px;
          color: #6b7280;
        }
        .footer-bottom-links {
          display: flex;
          gap: 24px;
        }
        .footer-bottom-links a {
          color: #6b7280;
          text-decoration: none;
          font-size: 13px;
          transition: color 0.15s ease;
        }
        .footer-bottom-links a:hover {
          color: #c8102e;
        }

        /* ============ RESPONSIVE ============ */
        @media (max-width: 1100px) {
          .footer-main {
            grid-template-columns: 1fr 1fr;
            gap: 40px;
          }
        }

        @media (max-width: 700px) {
          .footer-main {
            grid-template-columns: 1fr;
            gap: 36px;
            padding: 40px 24px 32px;
          }
          .footer-bottom-inner {
            padding: 20px 24px;
            flex-direction: column;
            text-align: center;
          }
          .footer-bottom-links {
            flex-wrap: wrap;
            justify-content: center;
            gap: 16px;
          }
          .footer-logo {
            height: 52px;
            width: 180px;
          }
          .footer-tagline {
            max-width: 100%;
          }
        }
      `}</style>
    </>
  );
}

export default Footer;